import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';

function trim(value: unknown): string {
  return value === null || value === undefined ? '' : String(value).trim();
}

/** B32106 — Notice for Controller (Individual); Register of Controllers (A50009) */
const noticeIndividualControllerDetailMap = {
  title: 'New Controller Details',
  fields: [
    {
      label: 'Full Name',
      key: [
        'controller_full_name',
        'controllerFullName',
        'controllerName',
      ],
    },
    {
      label: 'NRIC / FIN / Passport No',
      key: [
        'controller_identification_no',
        'controllerIdentificationNo',
      ],
    },
    {
      label: 'Date of Birth',
      key: [
        'controller_date_of_birth',
        'controllerDateOfBirth',
      ],
    },
    {
      label: 'Nationality',
      key: [
        'controller_nationality',
        'controllerNationality',
      ],
    },
    { label: 'Email', key: ['controller_email', 'controllerEmail'] },
    { label: 'Contact No', key: ['controller_contact_no', 'controllerContactNo'] },
    {
      label: 'Date became controller',
      key: [
        'controller_became_date',
        'controllerBecameDate',
        'dateOfBecoming',
        'dateOfAppointed',
      ],
    },
    {
      label: 'Residential Address',
      key: ['controller_residential_address', 'controllerResidentialAddress'],
    },
    {
      label: 'Aliases',
      key: ['controller_aliases', 'controllerAliases'],
    },
  ],
};

registerRegisterDetail('B32106', noticeIndividualControllerDetailMap);
